module.exports = {
          srcSet: __webpack_public_path__ + "images/1967-2c046e9831ac99be052b769b9be3ea27-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1967-91ecdb3a53392e8e5222fe4a198f3c96-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1967-2c046e9831ac99be052b769b9be3ea27-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1967-91ecdb3a53392e8e5222fe4a198f3c96-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1967-2c046e9831ac99be052b769b9be3ea27-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1967-2c046e9831ac99be052b769b9be3ea27-320.jpg"},
          
          width: 320,
          height: 251
        }